import React from 'react';
import UserEdit from './UserEdit';
import UserPhoneHistory from './UserPhoneHistory';

const TabContent = React.forwardRef(({ index, match }, ref) => {
  const activeTab = Number(index);
  return (
    <>
      {activeTab === 0 && <UserEdit ref={ref} match={match} />}
      {activeTab === 1 && <UserPhoneHistory match={match} />}
    </>
  );
});

export default TabContent;
